// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"79":"component---src-templates-suburb-page-tsx","351":"commons","904":"component---src-templates-area-page-tsx","988":"7a1ee894"}[chunkId] + "-" + {"79":"d765392d416650900055","351":"75a940b26710f9c6b229","904":"6d4f75c9c4dad92d0060","988":"cc6f1809ec3fc88aec1e"}[chunkId] + ".js";
};